<template>
  <div class="main-menu-custom">
    <!-- <vertical-nav-menu-user></vertical-nav-menu-user> -->
    <vertical-nav-menu-manage-filter></vertical-nav-menu-manage-filter>
  </div>
</template>

<script>
// import { BBadge } from "bootstrap-vue";
// import AppConstants from "@/appConstants";
import VerticalNavMenuManageFilter from "./VerticalNavMenuManageFilter.vue";
// import VerticalNavMenuUser from "./VerticalNavMenuUser.vue";

export default {
  components: {
    VerticalNavMenuManageFilter,
    // VerticalNavMenuUser,
  },
  computed: {
    
  },
  methods: {
    
  },
};
</script>

<style lang="scss">

</style>
